import Component from './applicant_import_dialog.vue'
export default Component
